var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderlist"},[_vm._v(" orderlist ")])
}
var staticRenderFns = []

export { render, staticRenderFns }